import { fromEvent, merge, Subject, timer } from 'rxjs';
import { mapTo, startWith, switchMap, takeUntil, tap, distinctUntilChanged } from 'rxjs/operators';

export class UserActivityAutoRefreshManager {
  private destroy$ = new Subject<void>();

  constructor(
    private refreshCallback: () => void,
    private ACTIVE_INTERVAL = 20_000,     // co 20s gdy aktywny
    private INACTIVE_INTERVAL = 120_000,  // co 120s gdy nieaktywny
    private IDLE_TIME = 4 * 60_000        // po 4 min bez ruchu -> nieaktywny
  ) {}

  init() {
    const activity$ = merge(
      fromEvent(window, 'mousemove'),
      fromEvent(window, 'keydown'),
      fromEvent(window, 'focus'),
      fromEvent(document, 'visibilitychange')
    );

    const inactivity$ = activity$.pipe(
      switchMap(() =>
        timer(this.IDLE_TIME).pipe(
          mapTo(true),
          startWith(false)
        )
      ),
      startWith(false),
      distinctUntilChanged()
    );

    inactivity$.pipe(
      switchMap(isInactive =>
        isInactive
          ? timer(this.INACTIVE_INTERVAL, this.INACTIVE_INTERVAL)
          : timer(0, this.ACTIVE_INTERVAL)
      ),
      takeUntil(this.destroy$),
      tap(() => this.refreshCallback())
    ).subscribe();
  }

  destroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public refreshNow() {
    this.refreshCallback();
  }
}
